// extracted by mini-css-extract-plugin
export var permissionsModal = "permissions-modal_A3aNwJcC9vL1MKX4aoPg";